import '../vue_widget_wrapper.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.SectionSeparator extends Monitoring.Views.Charts.VueWidgetWrapper

  className: 'item w2 h0'

  initialize: (@options = {}) ->
    super($.extend(@options, {
      widget: 'editable-text',
      title: '',
      data: {
        text: '',
        placeholder: ''
      },
      options: {
        editableTitle: true,
        enableNotes: false,
      }
    }))

    @widgetEvents = {
      'change': @updateText,
      'change-height': @changeHeight,
      'change-title': @changeTitle
    }

  afterAppend: =>
    @vueSortableBoundWidget.update({
      isLoading: false,
      title: @_settings['title'] || ''
      data: {
        text: @_settings['text'] || '',
        placeholder: @placeholder()
      }
    })

  placeholder: =>
    if @options.readonly
      ''
    else
      I18n.t('monitoring.dashboard.charts.section_separator.placeholder')

  updateText: (text) =>
    @_settings['text'] = text
    @vueSortableBoundWidget.update({
      data: {
        text: text,
        placeholder: @placeholder()
      }
    })
    @trigger('chartsChange')

  changeTitle: (title) =>
    @_settings['title'] = title
    @vueSortableBoundWidget.update({
      title: title
    })
    @trigger('chartsChange')

  changeHeight: () =>
    @trigger('masonry')
